import { store, currentTimestampFirestore } from "./firebase";

class UserServices {
  getUserProfile(userId) {
    return store
      .collection("users")
      .doc(userId)
      .get()
      .then(snapshot => {
        let user = snapshot.data();
        user.id = snapshot.id;
        return user;
      });
  }

  addUser(form) {
    form.createdAt = currentTimestampFirestore;
    return store
      .collection("users")
      .doc(form.id)
      .set(form);
  }

  createUserProfile(user) {
    return store
      .collection("users")
      .doc(user.uid)
      .set({
        id: user.uid,
        email: user.email
      });
  }

  updateUserProfile(user) {
    return store
      .collection("users")
      .doc(user.id)
      .update(user);
  }

  getUserDoneActivities(userId) {
    return store
      .collection("users")
      .doc(userId)
      .collection("doneActivities")
      .get()
      .then(querySnapshot => {
        let activities = [];
        querySnapshot.forEach(snapshot => {
          let activity = snapshot.data();
          activity.id = snapshot.id;
          activities.push(activity);
        });
        return activities;
      });
  }

  updateUserDoneActivity(userId, activityId, program) {
    return store
      .collection("users")
      .doc(userId)
      .collection("doneActivities")
      .doc(activityId)
      .set({
        updatedAt: currentTimestampFirestore,
        program: program
      });
  }
}

export default new UserServices();
